import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DrivingSchoolInformation.module.scss'
import { contactNameAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const ContactName = ({ t, validateContactName, contactNameError, contactNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const contactName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.contactName)

  const handleContactName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(contactNameAction(name))
      validateContactName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurContactName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(contactNameAction(name))
      validateContactName(contactName)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        contactNameValid === true
          ? contactName === ''
            ? ''
            : 'form-group has-success'
          : contactNameValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="ContactName">
        {t('driving_school_information.contact_name')}
      </label>
      <input
        type="text"
        id="ContactName"
        className="form-control"
        value={contactName}
        onChange={handleContactName}
        onFocus={() => SetIsFocussed(true)}
        onBlur={onBlurContactName}
        autoComplete="off"
        maxLength="150"
      />
      {contactNameValid === true ? (
        contactName === '' ? (
          ''
        ) : (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )
      ) : contactNameValid === false ? (
        <React.Fragment>
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(contactNameError)}</div>
        </React.Fragment>
      ) : (
            ''
          )}
    </div>
  )
}

export default withTranslation('common')(ContactName)
